import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { ProviderModule } from './provider.module';
platformBrowserDynamic().bootstrapModule(ProviderModule);
